import { Moment } from 'moment';
import { BookingId } from '@/booking/models/Booking';
import { OutletId } from '@/shared/models/Outlet';
import User from '@/shared/models/User';
import TaskStatus from '../constants/TaskStatus';
import TaskType from '../constants/TaskType';
import AbstractTask from './AbstractTask';
import Appointment from './Appointment';
import Keydrop from './Keydrop';

export interface TaskId {__taskId: number}

export default class Task extends AbstractTask {
  id!: TaskId;
  outletId!: OutletId;
  type!: TaskType;
  bookingId: BookingId | null = null;
  keydrop: Keydrop | null = null;
  isTaskOfCurrentIdentity = false;
  isGroupTask = false;
  isResolvable = false;
  status = TaskStatus.OPEN;
  createdBy: User | null = null;
  deadline: Moment | null = null;
  ownedBy: User | null = null;
  dossierOwnedBy: User | null = null;
  resolvedBy: User | null = null;
  appointment!: Appointment;

  isResolved(): boolean {
    return this.status === TaskStatus.RESOLVED;
  }

  isOpen(): boolean {
    return this.status === TaskStatus.OPEN;
  }

  canResolve(): boolean {
    return this.isResolvable && this.isOpen();
  }
}
